import api from './axios';

export const getQuotations = async (params) => {
  const response = await api.get('/quotations', { params });
  return response.data;
};

export const getQuotation = async (id) => {
  const response = await api.get(`/quotations/${id}`);
  return response.data;
};

export const createQuotation = async (data) => {
  const formData = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      formData.append(key, value);
    }
  });
  const response = await api.post('/quotations', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const updateQuotation = async (id, data) => {
  const response = await api.put(`/quotations/${id}`, data);
  return response.data;
};

export const deleteQuotation = async (id) => {
  const response = await api.delete(`/quotations/${id}`);
  return response.data;
};

export const getByService = async (serviceId) => {
  const response = await api.get(`/quotations/service/${serviceId}`);
  return response.data;
};

export const getPendingReview = async () => {
  const response = await api.get('/quotations/pending/review');
  return response.data;
};

export const compareQuotations = async (serviceId) => {
  const response = await api.get(`/quotations/compare/${serviceId}`);
  return response.data;
};

export const selectQuotation = async (id) => {
  const response = await api.post(`/quotations/${id}/select`);
  return response.data;
};

export const rejectQuotation = async (id, data) => {
  const response = await api.post(`/quotations/${id}/reject`, data);
  return response.data;
};

export const parseQuotationDocument = async (file) => {
  const formData = new FormData();
  formData.append('document', file);
  const response = await api.post('/quotations/parse-document', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};
